import { render } from "./RelatedCourses.vue?vue&type=template&id=273ccdc2&scoped=true"
import script from "./RelatedCourses.vue?vue&type=script&lang=js"
export * from "./RelatedCourses.vue?vue&type=script&lang=js"

import "./RelatedCourses.vue?vue&type=style&index=0&id=273ccdc2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-273ccdc2"

export default script